
import Vue from 'vue';
import api from '@/api/api';

const GETPRODETAILS = 'GETPRODETAILS';
const DATAINIT = 'DATAINIT'

export default {
	state: {
		productBean: {},
		productDetail: {},
		productSkuDetailList: [],//不同规格对应详情,商品对应的sku信息
		title:'',//商品页标题 
	},
	actions: {
		getDetails({ commit,state },goodsChannelId){
			return new Promise(function(resolve, reject){

				api.get('api/appclient/v2/product/'+goodsChannelId,'',function(res){
					commit(GETPRODETAILS,{data:res.body.data});
					resolve(res);
				})
			})
		},
		proInit({ commit,state }){
			commit('DATAINIT');
		}
	},
	mutations:{
		[GETPRODETAILS]( state, options){
			var resData = options.data;
			state.productBean = resData.frontGoods;
			state.productDetail = resData.goodsDetail;
            state.detailImages = resData.goodsDetail.detailImage;
			state.productSkuDetailList = resData.goodsSkuDetailList;
			state.title = resData.goodsDetail.title
		},
		[DATAINIT](state){
			state.productBean = {};
			state.productDetail = {};
			state.productSkuDetailList =  [];//不同规格对应详情,商品对应的sku信息
            state.detailImages = [];
            state.title='';//商品页标题
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/store/proDetails.js